import moment from 'moment-timezone';

export interface ITradesResponse {
  date_time: string;
  sequence: number;
  registry_type: string;
  volume: number;
  last_price: number;
  subtype: string;
  odd_lot: string;
  buyer: string;
  seller: string;
  security_id: string;
  is_sic: boolean;
}

export interface ITradesDigitalResponse {
  time: string;
  sequence: number;
  regType: string;
  operationVolume: number;
  last: number;
  typeOper: string;
  oddLot: string;
  buyer: string;
  seller: string;
  stockSeries: string;
  isSIC: boolean;
}

export interface ITradesSolaceResponse {
  Time: string;
  sequence: number;
  OperationVolume: number;
  lastWithLot: number;
  Buyer: string;
  Seller: string;
}

export interface ITrades {
  dateTime: string;
  sequence: number;
  registryType: string;
  volume: number;
  lastPrice: number;
  subtype: string;
  oddLot: string;
  buyer: string;
  seller: string;
  securityId: string;
  isSic: boolean;
}

export class TradesViewModel implements ITrades {
  static fromJSON(json: ITradesResponse): TradesViewModel {
    return new TradesViewModel(
      moment(json.date_time).format('LTS'),
      json.sequence,
      json.registry_type,
      json.volume,
      json.last_price,
      json.subtype,
      json.odd_lot,
      json.buyer,
      json.seller,
      json.security_id,
      json.is_sic,
    );
  }

  static fromDigitalJSON(json: ITradesDigitalResponse): TradesViewModel {
    return new TradesViewModel(
      moment(json.time).format('LTS'),
      json.sequence,
      json.regType,
      json.operationVolume,
      json.last,
      json.typeOper,
      json.oddLot,
      json.buyer,
      json.seller,
      json.stockSeries,
      json.isSIC,
    );
  }

  static fromSolaceJSON(json: ITradesSolaceResponse): TradesViewModel {
    return new TradesViewModel(
      moment(this.buildDate(json.Time)).format('LTS'),
      json.sequence,
      '',
      json.OperationVolume,
      json.lastWithLot,
      '',
      '',
      json.Buyer,
      json.Seller,
      '',
      false,
    );
  }

  static buildDate(time: string) {
    const today: any = new Date();
    const month =
      today.getMonth() + 1 > 9
        ? today.getMonth() + 1
        : `0${today.getMonth() + 1}`;
    return `${today.getFullYear()}-${month}-${today.getDate()} ${time}`;
  }

  constructor(
    public dateTime: string,
    public sequence: number,
    public registryType: string,
    public volume: number,
    public lastPrice: number,
    public subtype: string,
    public oddLot: string,
    public buyer: string,
    public seller: string,
    public securityId: string,
    public isSic: boolean,
  ) {}
}

export enum TRADING_USA_ORDER_STATUS {
  pending = 'pending',
  executing = 'executing',
  sent = 'sent',
  canceled = 'canceled',
  finishedTrading = 'finished_trading',
  executed = 'executed',
  executedWithErrors = 'executed_with_errors',
  rejected = 'rejected',
  expired = 'expired',
}

export enum TRADING_ORDER_STATUS {
  pendingNew = 'Pending-New',
  new = 'New',
  cancelPending = 'Cancel-Pending',
  cancelRejected = 'Cancel-Rjx',
  filled = 'Filled',
  partiallyFilled = 'PtlFil',
  cancelled = 'Cancelled',
  rejected = 'Reject',
  ackGbm = 'Ack-Gbm',
}

export enum TRADING_ORDER_STATUS_CUSTOM {
  cancelRejectedAndFilled = 'cancelRejectedAndFilled',
}

export enum TRADING_USA_ORDER_UNITS {
  shares = 'shares',
  amount = 'amount',
}

export enum TRADING_ORDER_WAYS {
  buy = 'Compra',
  sell = 'Venta',
}
